"use strict";

var _underscore = _interopRequireDefault(require("underscore"));

var _backboneOriginal = _interopRequireDefault(require("backbone-original"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// Updated to:
// 1. ES6 imports
// 2. Allow to async show a "unsaved changes" popup
// 3. Reset tracking after "read" api calls as well as other call methods
// 4. Allow tracking of add/remove from collection
(function () {
  // Unsaved Record Keeping
  // ----------------------
  // Collection of all models in an app that have unsaved changes.
  var unsavedModels = {}; // If the given model has unsaved changes then add it to
  // the `unsavedModels` collection, otherwise remove it.

  var updateUnsavedModels = function updateUnsavedModels(model) {
    var cid = model.cid || model._listenId;

    if (!_underscore.default.isEmpty(model._unsavedChanges)) {
      unsavedModels[cid] = model;
    } else {
      if (unsavedModels[cid]) {
        delete unsavedModels[cid];
      }
    }
  }; // Unload Handlers
  // ---------------
  // Helper which returns a prompt message for an unload handler.
  // Uses the given function name (one of the callback names
  // from the `model.unsaved` configuration hash) to evaluate
  // whether a prompt is needed/returned.


  var getPrompt = function getPrompt(fnName) {
    var prompt,
        args = _underscore.default.rest(arguments); // Evaluate and return a boolean result. The given `fn` may be a
    // boolean value, a function, or the name of a function on the model.


    var evaluateModelFn = function evaluateModelFn(model, fn) {
      if (_underscore.default.isBoolean(fn)) return fn;
      return (_underscore.default.isString(fn) ? model[fn] : fn).apply(model, args);
    };

    _underscore.default.each(unsavedModels, function (model) {
      if (!prompt && model._unsavedConfig[fnName + 'Async']) prompt = model._unsavedConfig[fnName + 'Async'];
      if (!prompt && evaluateModelFn(model, model._unsavedConfig[fnName])) prompt = model._unsavedConfig.prompt;
    });

    return prompt;
  }; // Wrap Backbone.History.navigate so that in-app routing
  // (`router.navigate('/path')`) can be intercepted with a
  // confirmation if there are any unsaved models.


  _backboneOriginal.default.History.prototype.navigate = _underscore.default.wrap(_backboneOriginal.default.History.prototype.navigate, function (oldNav, fragment, options) {
    var prompt = getPrompt('unloadRouterPrompt', fragment, options);

    if (_underscore.default.isFunction(prompt)) {
      prompt(fragment, options, _underscore.default.bind(function (shouldNavigate) {
        if (shouldNavigate) {
          oldNav.call(this, fragment, options);
        }
      }, this));
    } else if (prompt) {
      if (confirm(prompt + ' \n\nAre you sure you want to leave this page?')) {
        oldNav.call(this, fragment, options);
      }
    } else {
      oldNav.call(this, fragment, options);
    }
  });

  _backboneOriginal.default.History.prototype.showPromptIfNeeded = function (callback, options) {
    var prompt = getPrompt('unloadRouterPrompt');

    if (_underscore.default.isFunction(prompt)) {
      prompt('', options, callback);
    } else {
      callback(true);
    }
  }; // Create a browser unload handler which is triggered
  // on the refresh, back, or forward button.


  window.onbeforeunload = function (e) {
    return getPrompt('unloadWindowPrompt', e);
  }; // Backbone.Model API
  // ------------------


  _underscore.default.extend(_backboneOriginal.default.Model.prototype, {
    unsaved: {},
    _trackingChanges: false,
    _originalAttrs: {},
    _unsavedChanges: {},
    // Opt in to tracking attribute changes
    // between saves.
    startTracking: function startTracking() {
      this._unsavedConfig = _underscore.default.extend({}, {
        prompt: 'You have unsaved changes!',
        unloadRouterPrompt: false,
        unloadWindowPrompt: false
      }, this.unsaved || {});
      this._trackingChanges = true;

      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Resets the default tracking values
    // and stops tracking attribute changes.
    stopTracking: function stopTracking() {
      this._trackingChanges = false;
      this._originalAttrs = {};
      this._unsavedChanges = {};

      this._triggerUnsavedChanges();

      return this;
    },
    // Gets rid of accrued changes and
    // resets state.
    restartTracking: function restartTracking() {
      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Restores this model's attributes to
    // their original values since tracking
    // started, the last save, or last restart.
    resetAttributes: function resetAttributes() {
      if (!this._trackingChanges) return;
      this.attributes = this._originalAttrs;

      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Symmetric to Backbone's `model.changedAttributes()`,
    // except that this returns a hash of the model's attributes that
    // have changed since the last save, or `false` if there are none.
    // Like `changedAttributes`, an external attributes hash can be
    // passed in, returning the attributes in that hash which differ
    // from the model.
    unsavedAttributes: function unsavedAttributes(attrs) {
      if (!attrs) return _underscore.default.isEmpty(this._unsavedChanges) ? false : _underscore.default.clone(this._unsavedChanges);
      var val,
          changed = false,
          old = this._unsavedChanges;

      for (var attr in attrs) {
        if (_underscore.default.isEqual(old[attr], val = attrs[attr])) continue;
        (changed || (changed = {}))[attr] = val;
      }

      return changed;
    },
    _resetTracking: function _resetTracking() {
      this._originalAttrs = _underscore.default.clone(this.attributes);
      this._unsavedChanges = {};
    },
    // Trigger an `unsavedChanges` event on this model,
    // supplying the result of whether there are unsaved
    // changes and a changed attributes hash.
    _triggerUnsavedChanges: function _triggerUnsavedChanges() {
      this.trigger('unsavedChanges', !_underscore.default.isEmpty(this._unsavedChanges), _underscore.default.clone(this._unsavedChanges), this);
      if (this.unsaved) updateUnsavedModels(this);
    }
  }); // Wrap `model.set()` and update the internal
  // unsaved changes record keeping.


  _backboneOriginal.default.Model.prototype.set = _underscore.default.wrap(_backboneOriginal.default.Model.prototype.set, function (oldSet, key, val, options) {
    var attrs, ret;
    if (key == null) return this; // Handle both `"key", value` and `{key: value}` -style arguments.

    if (_typeof(key) === 'object') {
      attrs = key;
      options = val;
    } else {
      (attrs = {})[key] = val;
    }

    options || (options = {}); // Delegate to Backbone's set.

    ret = oldSet.call(this, attrs, options);

    if (this._trackingChanges && !options.silent && !options.trackit_silent) {
      var filteredAttrs = this.trackit_ignore ? _underscore.default.omit(attrs, this.trackit_ignore) : attrs;

      _underscore.default.each(filteredAttrs, _underscore.default.bind(function (val, key) {
        if (_underscore.default.isEqual(this._originalAttrs[key], val)) delete this._unsavedChanges[key];else this._unsavedChanges[key] = val;
      }, this));

      this._triggerUnsavedChanges();
    }

    return ret;
  });

  _underscore.default.extend(_backboneOriginal.default.Collection.prototype, {
    unsaved: {},
    _trackingChanges: false,
    _originalModels: [],
    _unsavedChanges: {},
    // Opt in to tracking attribute changes
    // between saves.
    startTracking: function startTracking() {
      this._unsavedConfig = _underscore.default.extend({}, {
        prompt: 'You have unsaved changes!',
        unloadRouterPrompt: false,
        unloadWindowPrompt: false
      }, this.unsaved || {});
      this._trackingChanges = true;

      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Resets the default tracking values
    // and stops tracking attribute changes.
    stopTracking: function stopTracking() {
      this._trackingChanges = false;
      this._originalModels = [];
      this._unsavedChanges = {};

      this._triggerUnsavedChanges();

      return this;
    },
    // Gets rid of accrued changes and
    // resets state.
    restartTracking: function restartTracking() {
      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Restores this model's attributes to
    // their original values since tracking
    // started, the last save, or last restart.
    resetAttributes: function resetAttributes() {
      if (!this._trackingChanges) return;
      this.reset(this._originalModels);

      this._resetTracking();

      this._triggerUnsavedChanges();

      return this;
    },
    // Symmetric to Backbone's `model.changedAttributes()`,
    // except that this returns a hash of the model's attributes that
    // have changed since the last save, or `false` if there are none.
    // Like `changedAttributes`, an external attributes hash can be
    // passed in, returning the attributes in that hash which differ
    // from the model.
    unsavedAttributes: function unsavedAttributes() {
      return _underscore.default.isEmpty(this._unsavedChanges) ? false : _underscore.default.clone(this._unsavedChanges);
    },
    _resetTracking: function _resetTracking() {
      this._originalModels = _underscore.default.clone(this.models);
      this._unsavedChanges = {};
    },
    // Trigger an `unsavedChanges` event on this model,
    // supplying the result of whether there are unsaved
    // changes and a changed attributes hash.
    _triggerUnsavedChanges: function _triggerUnsavedChanges() {
      this.trigger('unsavedChanges', !_underscore.default.isEmpty(this._unsavedChanges), _underscore.default.clone(this._unsavedChanges), this);
      if (this.unsaved) updateUnsavedModels(this);
    }
  }); // Wrap `collection.add()` & `collection.remove()` and update the internal
  // unsaved changes record keeping.


  var collectionTracking = function collectionTracking(func) {
    var ret = func.apply(this, _underscore.default.rest(arguments));

    if (this._trackingChanges) {
      if (_underscore.default.isEqual(this.models, this._originalModels)) {
        this._unsavedChanges = false;
      } else {
        this._unsavedChanges = {
          add: _underscore.default.difference(this.models, this._originalModels),
          remove: _underscore.default.difference(this._originalModels, this.models)
        };
      }

      this._triggerUnsavedChanges();
    }

    return ret;
  };

  _backboneOriginal.default.Collection.prototype.add = _underscore.default.wrap(_backboneOriginal.default.Collection.prototype.add, collectionTracking);
  _backboneOriginal.default.Collection.prototype.remove = _underscore.default.wrap(_backboneOriginal.default.Collection.prototype.remove, collectionTracking);
  _backboneOriginal.default.Collection.prototype.set = _underscore.default.wrap(_backboneOriginal.default.Collection.prototype.set, collectionTracking);
  _backboneOriginal.default.Collection.prototype.reset = _underscore.default.wrap(_backboneOriginal.default.Collection.prototype.reset, collectionTracking); // Intercept `model.save()` and reset tracking/unsaved
  // changes if it was successful.

  _backboneOriginal.default.sync = _underscore.default.wrap(_backboneOriginal.default.sync, function (oldSync, method, model, options) {
    options || (options = {});

    if (method == 'read' || method == 'update' || method == 'create' || method == 'patch') {
      options.success = _underscore.default.wrap(options.success, _underscore.default.bind(function (oldSuccess, data, textStatus, jqXHR) {
        var ret;
        if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);

        if (model._trackingChanges) {
          model._resetTracking();

          model._triggerUnsavedChanges();
        }

        return ret;
      }, this));
    }

    return oldSync(method, model, options);
  });
})();